import { createHttp } from '@brickflow/http'

import { initDIContainer } from '@/core/di-2'
import { createResponseInterceptor, createSocket } from '@/core/transports'

export default defineNuxtPlugin((app) => {
  const { hook, runWithContext, vueApp } = app
  const localeInst = useLocale()
  provideBrickflow(vueApp, {
    i18n: localeInst,
  })
  const config = useRuntimeConfig()
  const rootStore = useBrickRootStore()
  const userStore = useBrickUserStore()
  const wasHydration = useState('wasHydration', () => false)

  hook('app:beforeMount', () => {
    wasHydration.value = true
  })

  const host = getHost(config)
  let apiUrl = `https://api.${host}`

  if (import.meta.server && !config.public.isDev) {
    apiUrl = `http://${config.public.serverHost}`
  }

  const socketClient = createSocket(`https://io.${host}`, userStore)
  const { locale } = localeInst

  const httpClient = createHttp({
    arrayMode: 'repeat',
    baseURL: apiUrl,
    headers: () => ({
      'X-Client-Language': String(locale.value ?? 'en'),
      'X-CSRF-TOKEN': String(rootStore.token),
      'X-Document-Referrer': import.meta.client ? document.referrer : undefined,
      'X-Requested-With': 'XMLHttpRequest',
    }),
    onResponse: createResponseInterceptor(wasHydration, (callback) => runWithContext(callback)),
    timeout: 180000,
  })

  const di = initDIContainer({ httpClient, localeInst, route: useRoute(), router: useRouter(), socketClient }, app)
  return {
    provide: {
      di,
      http: httpClient,
    },
  }
})
